import React from "react";

const Succes = () => {
  return <div>Succes</div>;
};

export default Succes;
